var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"c-modal-mask-fade"}},[(_vm.show)?_c('div',{staticClass:"c-modal-mask",class:{ '-transparent': _vm.transparent },attrs:{"data-cy":"c-modal-mask"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-193ec9bb","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CModalMask.vue
// module id = 2217
// module chunks = 1612